<nav>
    <li><a routerLink="">main</a></li>
    <li><a routerLink="/login">login</a></li>
    <li><a routerLink="/location">location</a></li>
  
  </nav>
  